<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12 has-text-centered">
        <button class="button" v-show="!showCalendar" @click="showCalendar = true"><font-awesome-icon icon="eye" />Visualizza calendario</button>
        <button class="button" v-show="showCalendar" @click="showCalendar = false"><font-awesome-icon icon="eye-slash" />Nascondi calendario</button>
      </div>
      <div class="column is-12" v-show="showCalendar">
        <div class="columns is-multiline">
          <div class="column is-12-mobile is-3-tablet">
            <InputSelect
              name="Collaboratore"
              v-model="filterCalendar.operator"
              :options="$store.getters.operators"
              id="_id"
              track-by="_id"
              :custom-label="$fullname"
            />
          </div>
        </div>
      </div>
      <div class="column is-12" v-show="showCalendar">
        <WeekCalendar :operator="filterCalendar.operator" @refresh="refreshOperations($event)" :forceUpdate="forceUpdateCal" @onForceUpdate="forceUpdateCal = false" />
      </div>

      <div class="column is-12-mobile is-2-tablet">
        <InputSelect
          name="Filtro cliente"
          v-model="filters.client"
          :options="clients"
          :loading="waitClients"
          :disabled="waitClients"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="filterClient"
          @remove="filterClient(false)"
        />
      </div>
      <div class="column is-12-mobile is-3-tablet">
        <div class="field">
          <label class="label">Intervallo date appuntamenti</label>
          <InputDate v-model="filters.operationRange" @update="onFilterInput" placeholder="Intervallo appuntamenti" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-3-tablet">
        <div class="field">
          <label class="label">Intervallo date chiamate</label>
          <InputDate v-model="filters.callRange" @update="onFilterInput" placeholder="Intervallo chiamate" :range="true" :showIcon="true" />
        </div>
      </div>
      <div class="column is-12-mobile is-3-tablet">
        <div class="field">
          <label class="label">Intervallo date scadenze</label>
          <InputDate v-model="filters.expireRange" @update="onFilterInput" placeholder="Intervallo scadenze" :range="true" :showIcon="true" />
          <div class="buttons mt-2">
            <button class="button is-small" type="button" @click="setExpireRangeSince2019()">Dal 2019 a 30 giorni fa</button>
            <button class="button is-small" type="button" @click="setExpireRangePastMonth()">Mese passato</button>
          </div>
        </div>
      </div>
      <!--<div class="column is-12-mobile is-1-tablet">
        <div class="field">
          <label class="label">Senza data</label>
          <div class="control">
            <input type="checkbox" v-model="filters.noDate" @change="filterOperators()">
          </div>
        </div>
      </div>-->
      <div class="column is-12-mobile is-1-tablet">
        <label class="label">&nbsp;</label>
        <div class="buttons">
          <button class="button" @click="resetFilters()"><font-awesome-icon icon="filter-circle-xmark" />Reset</button>
          <!--<button class="button is-primary" @click=" showModalAssign()" :disabled="!selected"><font-awesome-icon icon="user-plus" />Assegna</button>-->
        </div>
      </div>
    </div>
  
    <div class="columns is-desktop map-layout">
      <div class="column is-half">
        <div class="tabs is-boxed mb-0">
          <ul>
            <li :class="{'is-active': activeTab === 'operation'}" @click="activeTab = 'operation'">
              <a><img class="mr-1" style="height: 16px;" :src="$image('map-pin-operation.svg')">Appuntamenti ({{ operations.length }})</a>
            </li>
            <li :class="{'is-active': activeTab === 'call'}" @click="activeTab = 'call'">
              <a><img class="mr-1" style="height: 16px;" :src="$image('map-pin-place.svg')">Chiamate ({{ calls.length }})</a>
            </li>
            <li :class="{'is-active': activeTab === 'expire'}" @click="activeTab = 'expire'">
              <a><img class="mr-1" style="height: 16px;" :src="$image('map-pin-deadline.svg')">Scadenze ({{ expires.length }})</a>
            </li>
          </ul>
        </div>

        <div class="b-table has-pagination" :class="{'is-loading': loading}">
          <div class="table-wrapper has-mobile-cards">
            <table class="table is-fullwidth is-striped is-hoverable">
              <thead>
                <tr>
                  <th style="width: 40px;"></th>
                  <th>Cliente</th>
                  <th style="width: 40px;"></th>
                  <th>Luogo</th>
                  <th>Impianto</th>
                  <th>Data</th>
                  <th v-if="activeTab === 'expire'">Tipologia</th>
                  <th style="width: 80px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in visibleFilteredList" :key="itemRowKey(item, index)" :data-row-key="itemRowKey(item, index)" :class="{'is-selected': item.selected}" @click="toggleItemSelection(item)">
                  <td>
                    <label class="checkbox">
                      <input type="checkbox" :checked="!!item.selected" @click.stop @change="toggleItemSelection(item)">
                    </label>
                  </td>
                  <td data-label="Cliente">
                    <router-link v-if="item.client || item.occupant" :to="'/clienti/' + (item.client?._id || item.occupant?._id)">
                      <ClientHeading :client="item.client || item.occupant" />
                    </router-link>
                  </td>
                  <td>
                    <font-awesome-icon v-if="item.place || item.place_occupant" class="has-text-danger" :class="{'has-text-grey-lighter': !(item.place?.position || item.place_occupant?.position)}" icon="location-dot" />
                  </td>
                  <td data-label="Luogo">
                    <router-link v-if="item.place" :to="'/luoghi/' + item.place._id">
                      <div>{{item.place.city}}</div>
                      <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(item.place)">{{$fulladdress(item.place)}}</small></div>
                    </router-link>
                    <router-link v-else-if="item.place_occupant" :to="'/luoghi/' + item.place_occupant._id">
                      <div>{{item.place_occupant.city}}</div>
                      <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(item.place_occupant)">{{$fulladdress(item.place_occupant)}}</small></div>
                    </router-link>
                  </td>
                  <td data-label="Impianto">
                    <router-link v-if="item.implant" :to="'/impianti/' + item.implant._id">
                      {{$implantName(item.implant)}}
                    </router-link>
                    <router-link v-else-if="item.system" :to="'/impianti/' + item.system._id">
                      {{item.system.name}}
                    </router-link>
                  </td>
                  <td data-label="Data">
                    <div v-if="item.appointment_date">{{new Date(item.appointment_date).toDisplay()}}</div>
                    <div v-else-if="item.date">{{new Date(item.date).toDisplay()}}</div>
                    <div v-else-if="item.expire">{{new Date(item.expire).toDisplay()}}</div>
                  </td>
                  <td v-if="activeTab === 'expire'" data-label="Tipologia">
                    <span v-if="item.type === 'expire'">{{ item.itemType }}</span>
                  </td>
                  <td class="is-actions-cell is-justify-content-flex-end">
                    <router-link v-if="item.type === 'operation'" :to="'/appuntamenti/' + item._id" class="button is-primary" @click.stop><font-awesome-icon icon="file-lines" class="m-0" /></router-link>
                    <router-link v-else-if="item.type === 'call'" :to="'/chiamate/' + item._id" class="button is-warning" @click.stop><font-awesome-icon icon="phone" class="m-0" /></router-link>
                    <button v-else-if="item.type === 'expire' && !item.operation" class="button is-success is-rounded" @click.stop="openAppointment(item)"><font-awesome-icon icon="plus" class="m-0" /></button>
                    <router-link v-else-if="item.type === 'expire' && item.operation" :to="'/appuntamenti/' + item.operation" class="button is-primary" @click.stop><font-awesome-icon icon="file-lines" class="m-0" /></router-link>
                  </td>
                </tr>
                <tr v-if="filteredList.length === 0">
                  <td colspan="100" class="has-text-centered has-text-grey">
                    <i>Nessun risultato</i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="has-text-centered mt-3" v-if="filteredList.length > renderLimit">
            <button class="button is-light" type="button" @click="loadMoreRows()" v-if="visibleFilteredList.length < filteredList.length">
              Mostra altri {{ renderStep }} ({{ visibleFilteredList.length }}/{{ filteredList.length }})
            </button>
            <button class="button is-light" type="button" @click="resetVisibleRows()" v-else>
              Mostra meno
            </button>
          </div>
          <!--<Pagination :pagination="pagination" @change="getExpires($event)" />-->
        </div>
      </div>
      <div class="column map-side">
        <div class="map-sticky">
        <div class="is-flex mb-2 map-legend">
          <div class="is-flex is-align-content-center mr-3 is-size-7"><img class="mr-1" style="height: 18px;" :src="$image('map-pin-home.svg')">Sede</div>
          <div class="is-flex is-align-content-center mr-3 is-size-7"><img class="mr-1" style="height: 18px;" :src="$image('map-pin-operation.svg')">Appuntamenti</div>
          <div class="is-flex is-align-content-center mr-3 is-size-7"><img class="mr-1" style="height: 18px;" :src="$image('map-pin-place.svg')">Chiamate</div>
          <div class="is-flex is-align-content-center mr-3 is-size-7"><img class="mr-1" style="height: 18px;" :src="$image('map-pin-deadline.svg')">Scadenze</div>
        </div>
        <MapGoogle :places="mapPlaces" :infos="[]" @select="onSelect" :selected="selected" :itemsData="itemsWithCoordinates" :mapHeight="'calc(100vh - 250px)'" />
        </div>
      </div>
    </div>

    <AppointmentCalendar :deadline="deadline" :open="openModalAppointment" @close="this.openModalAppointment = false" @saved="savedAppointment()" />

    <!--<Modal :title="'Assegna appuntamenti'" :openModal="openModalAssign" @close="openModalAssign = false" @success="saveAssign()" :loading="waitAssign" style="width: 100%;max-width: 1400px; position: relative">
      <div class="field">
        <label class="label">Collaboratori</label>
        <div class="control">
          <multiselect v-model="assign.operators" :options="$store.getters.operators" placeholder="Collaboratore" id="_id" track-by="_id" :custom-label="$fullname"></multiselect>
        </div>
      </div>
      <div class="table-container">
        <table class="table is-fullwidth is-striped is-hoverable" v-if="openModalAssign">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Luogo</th>
              <th>Impianto</th>
              <th>Data</th>
              <th>Ora inizio</th>
              <th>Ora fine</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(operation, index) in selected" :key="index">
              <td>
                <ClientHeading :client="operation.client" />
              </td>
              <td>
                <div>{{operation.place.city}}</div>
                <div><small class="has-text-grey is-abbr-like" :title="$fulladdress(operation.place)">{{$fulladdress(operation.place)}}</small></div>
              </td>
              <td>
                {{operation.implant.type}} {{operation.implant.model}} {{operation.implant.code}}
              </td>
              <td>
                <input class="input" type="date" placeholder="Data" v-model="assign.elements[operation._id].date" />
              </td>
              <td>
                <input class="input" type="time" placeholder="Ora inizio"  v-model="assign.elements[operation._id].start" />
              </td>
              <td>
                <input class="input" type="time" placeholder="Ora fine"  v-model="assign.elements[operation._id].end" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>-->
  </div>
</template>

<script>
import utils from '../utils'

export default {
  data() {
    return {
      filters: this.$store.state.filters.operationMap,

      filterCalendar: {
        operator: null
      },

      clients: [],

      operations: [],
      expires: [],
      calls: [],
      unifiedList: [],

      pagination:{
        total: false,
        selected: false
      },

      loading: true,
      waitClients: true,

      openModalAssign: false,
      waitAssign: false,
      assign: {
        operators: null,
        elements: {}
      },

      showCalendar: false,
      forceUpdateCal: false,

      openModalAppointment: false,
      deadline: {},

      activeTab: 'operation',

      renderLimit: 150,
      renderStep: 150
    }
  },

  computed: {
    filteredList() {
      return this.unifiedList.filter(item => item.type === this.activeTab)
    },

    visibleFilteredList() {
      return this.filteredList.slice(0, this.renderLimit)
    },

    itemsWithCoordinates() {
      return this.unifiedList.filter(item => {
        const itemPlace = item.place || item.place_occupant
        return !!itemPlace?.position
      })
    },

    mapPlaces() {
      const map = new Map()

      this.itemsWithCoordinates.forEach(item => {
        const itemPlace = item.place || item.place_occupant
        if (itemPlace?._id && !map.has(itemPlace._id)) {
          map.set(itemPlace._id, itemPlace)
        }
      })

      return [...map.values()]
    },

    selected() {
      return this.unifiedList.filter(op => op.selected)
    }
  },

  methods: {
    ensureMapRanges() {
      const defaultRange = {start: utils.getFirstDayOfWeek(), end: utils.getLastDayOfWeek()}

      if (!this.filters || typeof this.filters !== 'object') {
        this.filters = {}
      }

      if (!this.filters.operationRange?.start || !this.filters.operationRange?.end) {
        this.filters.operationRange = {...defaultRange}
      }

      if (!this.filters.callRange?.start || !this.filters.callRange?.end) {
        this.filters.callRange = {...defaultRange}
      }

      if (!this.filters.expireRange?.start || !this.filters.expireRange?.end) {
        this.filters.expireRange = {start: utils.getFirstDayOfMonth(), end: utils.getLastDayOfMonth()}
      }
    },

    itemRowKey(item, index = 0) {
      return `${item.type}-${item._id || index}`
    },

    filterOperators(selected) {
      this.filters.operator = selected
    },

    resetFilters() {
      const defaultRange = {start: utils.getFirstDayOfWeek(), end: utils.getLastDayOfWeek()}

      this.filters = {
        text: '',
        operationRange: {...defaultRange},
        callRange: {...defaultRange},
        expireRange: {start: utils.getFirstDayOfMonth(), end: utils.getLastDayOfMonth()}
      }

      this.getData()
    },

    setExpireRangeSince2019() {
      this.filters.expireRange = {start: new Date(2019, 0, 1), end: utils.getBefore30Day()}
      this.getData()
    },

    setExpireRangePastMonth() {
      this.filters.expireRange = {start: utils.getFirstDayOfPastMonth(), end: utils.getLastDayOfPastMonth()}
      this.getData()
    },

    filterClient(selected) {
      this.filters.client = selected
      this.getData()
    },

    async getData() {
      this.loading = true

      this.ensureMapRanges()

      this.$store.commit('setFilter', {name: 'operationMap', value: this.filters})

      const clientId = this.filters.client ? this.filters.client._id : null

      const operationStartDate = this.filters.operationRange.start.toDateInputValue()
      const operationEndDate = this.filters.operationRange.end.toDateInputValue()
      const callStartDate = this.filters.callRange.start.toDateInputValue()
      const callEndDate = this.filters.callRange.end.toDateInputValue()
      const expireStartDate = this.filters.expireRange.start.toDateInputValue()
      const expireEndDate = this.filters.expireRange.end.toDateInputValue()

      try {
        const [operationsRes, callsRes, expiresRes] = await Promise.all([
          this.$http.get('/operation', {
            params: { page: 1, size: -1, startDate: operationStartDate, endDate: operationEndDate, client: clientId, noStatus: true }
          }),
          this.$http.get('/call', {
            params: { page: 1, size: -1, archived: false, startDate: callStartDate, endDate: callEndDate, client: clientId }
          }),
          this.$http.get('/revision/deadline', {
            params: { size: 999, client: clientId, startDate: expireStartDate, endDate: expireEndDate, operation: false }
          })
        ])

        this.operations = operationsRes?.data?.records || []
        this.calls = callsRes?.data?.records || []
        this.expires = expiresRes?.data?.records || []

        // Unifica le liste
        this.unifiedList = [
          ...this.operations.map(op => ({...op, type: 'operation', itemType: 'Appuntamento'})),
          ...this.calls.map(call => ({...call, type: 'call', itemType: 'Chiamata'})),
          ...this.expires.map(exp => ({...exp, type: 'expire', itemType: exp.type || 'Manutenzione'}))
        ]

        this.resetVisibleRows()

        this.loading = false
      } catch (error) {
        console.log(error)
        alert('Errore')
        this.loading = false
      }
    },

    /*deleteOperation(operation) {
      if (confirm('Eliminare?')) {
        const self = this
        operation.waitDelete = true

        this.$http.delete('/operation/' + operation._id)
        .then(function (response) {
          self.getOperations()
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          operation.waitDelete = false
        })
      }
    },*/

    toggleItemSelection(item) {
      const wasSelected = !!item.selected

      this.unifiedList.forEach(el => {
        el.selected = false
      })

      item.selected = !wasSelected
    },

    onSelect(payload) {
      const place = payload?.place || payload
      const markerType = payload?.type || null

      const related = this.unifiedList.filter(item => {
        const itemPlace = item.place || item.place_occupant
        return itemPlace && itemPlace._id === place._id
      })

      if (!related.length) {
        return
      }

      const preferred =
        related.find(item => item.type === markerType) ||
        related.find(item => item.type === this.activeTab) ||
        related[0]

      this.activeTab = preferred.type
      this.toggleItemSelection(preferred)

      this.$nextTick(() => {
        this.scrollToSelectedItem(preferred)
      })
    },

    scrollToSelectedItem(item) {
      if (!item) {
        return
      }

      const rowKey = this.itemRowKey(item)
      const row = this.$el?.querySelector(`[data-row-key="${rowKey}"]`)
      if (!row) {
        return
      }

      row.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
    },

    resetVisibleRows() {
      this.renderLimit = this.renderStep
    },

    loadMoreRows() {
      this.renderLimit += this.renderStep
    },

    /*showModalAssign() {
      const self = this

      this.openModalAssign = true

      this.assign.elements = {}
      this.selected.forEach(s => {
        self.assign.elements[s._id] = {
          date: s.appointment_date,
          start: s.appointment_start,
          end: s.appointment_end,
        }
      })
    },

    saveAssign() {
      const self = this
      self.waitAssign = true

      const operators = (this.assign.operators) ? [this.assign.operators._id] : false

      this.$http.post('/operation/save-multiple', {operators: operators, elements: this.assign.elements})
      .then(function (response) {
        self.getOperations()
        self.waitAssign = false
        self.openModalAssign = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
        self.waitAssign = false
      })
    },*/



    refreshOperations(event) {
      this.operations = event
    },

    openAppointment(deadline) {
      this.deadline = deadline
      this.openModalAppointment = true
    },

    savedAppointment() {
      this.openModalAppointment = false

      this.getData()
      this.forceUpdateCal = true
    }
  },

  mounted() {
    const self = this

    this.ensureMapRanges()

    this.$http.get('/client/filter')
    .then(function (response) {
      self.clients = response.data

      self.waitClients = false
    })
    .catch(function (error) {
      console.log(error)
      alert('Errore')
    })
    
    this.getData()
  },

  created() {
    this.onFilterInput = this.$debounce(() => {
      this.getData()
    }, 500)
  },

  watch: {
    activeTab() {
      this.resetVisibleRows()
    }
  }
}
</script>

<style scoped>
.map-layout {
  align-items: flex-start;
  overflow: visible;
}

.map-side {
  position: -webkit-sticky;
  position: sticky;
  top: 52px;
  align-self: flex-start;
  height: fit-content;
  overflow: visible;
}

.map-sticky {
  position: static;
}

.map-legend {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  padding-bottom: 0.25rem;
}

@media screen and (max-width: 1023px) {
  .map-side {
    position: static;
    top: auto;
  }
}

</style>